import React, { useContext, useState } from "react";
import {
	MenuFoldOutlined,
	MenuUnfoldOutlined,
	UserOutlined,
} from "@ant-design/icons";
import {
	Layout,
	Button,
	Avatar,
	Space,
	Popover,
	Card,
	Flex,
	List,
} from "antd";
import { UserContext } from "../../Context";
import { getCookie, COOKIE } from "../../Services/Cookie";
import constants from "../../Constants/constants";
import { Link, useNavigate } from "react-router-dom";
import { badgeNotification, notificationHandler, NotificationList, logOut, updateNotificationUrl } from "../../GlobalFunctions/GlobalFunctions";

const { Header } = Layout;

const Headers = ({ countData }) => {
	const navigate = useNavigate();
	const { collapsed, profileImage, toggleCollapsed, setSelectedMenuItem, setSelectedSubMenuItem, setBreadcrumbItems, session } = useContext(UserContext);
	const [isPopoverOpen, setIsPopoverOpen] = useState(false);
	const [reloadTab, setReloadTab] = useState(false);
	const [visible, setVisible] = useState(false);
	const userRole = getCookie(COOKIE.Role);
	const isStudent = userRole === '0'
	const username = session.shortName

	const showProfile = () => {
		if (profileImage) return <Avatar icon={<img src={profileImage} alt="profile" />} />
		else return <Avatar icon={<UserOutlined />} />
	}

	const navigateToModule = (destination) => {
		// deselect menu items when navigating to profile
		if (destination === "profile") {
			setSelectedMenuItem("");
			setSelectedSubMenuItem("");
			sessionStorage.removeItem("selectedMenuItem");
			sessionStorage.removeItem("selectedSubMenuItem");
		}

		navigate(`/${destination}`, {
			state: { editrecord: getCookie(COOKIE.UserId), isProfile: true },
		});
		setIsPopoverOpen(false);
	};

	const profileMenu = (
		<div className="profile-main" onMouseLeave={() => setIsPopoverOpen(false)}>
			<Card className="profileCard text-center">
				{showProfile()}
				<br></br>
				<span className="profile-name">{username}</span>
			</Card>
			<Flex gap={"small"} horizontal className="profile-menu-footer">
				<Button
					className="bgGreen500"
					onClick={() => navigateToModule("profile")}
				>
					{constants.Profile}
				</Button>
				<Button onClick={() => navigateToModule("change-password")} className="change-password-btn">
					{constants.ChangePassword}
				</Button>
				<Button onClick={logOut} type="primary" danger>
					{constants.SignOut}
				</Button>
			</Flex>
		</div>
	);

	const handleNotificationClick = (notif) => {
		setReloadTab(!reloadTab)
		// if(notif?.faculty_id === userId) 
		// 	createCookie("facultyId", notif?.faculty_id, null, "/");
		let semesterData = JSON.parse(sessionStorage.getItem('semesterData'))
		if (notif?.notification_url?.includes('answer-survey')) {
			notif = updateNotificationUrl(notif, semesterData)
		}
		notificationHandler(
			notif,
			navigate,
			{
				isStudent,
				reloadTab: !reloadTab,
				setSelectedMenuItem: setSelectedMenuItem,
				setSelectedSubMenuItem: setSelectedSubMenuItem,
				setBreadcrumbItems: setBreadcrumbItems,
			}
		)
		setVisible(false);
	}

	const renderItemHeader = (item) => {
		return (
			<NotificationList
				item={item}
				onClickHandler={() => handleNotificationClick(item)}
			/>
		)
	};

	const handleOnLoadMoreClick = () => {
		sessionStorage.removeItem('selectedSubMenuItem')
		setSelectedSubMenuItem('')
		setVisible(false)
	}

	const loadMoreFunction = () => (
		<div className="view-button">
			<Button type="link" onClick={handleOnLoadMoreClick}>
				<Link to="/notifications">{constants.ViewMore}</Link>
			</Button>
		</div>
	);

	return (
		<Header className="main-header">
			<Button
				type="text"
				icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
				onClick={toggleCollapsed}
				className="text-white menu-btn !invisible md:!visible"
			/>
			<Space>
				{countData?.length > 0 ? (
					<Popover
						overlayClassName="notification-popover"
						content={
							<List
								size="large"
								className="list-size"
								bordered
								dataSource={countData?.slice(0, 5)}
								renderItem={renderItemHeader}
								loadMore={loadMoreFunction()}
							/>
						}
						trigger="click"
						open={visible}
						onOpenChange={setVisible}
					>
						{badgeNotification(countData)}
					</Popover>
				) : badgeNotification(countData)}

				<Popover
					content={profileMenu}
					trigger="click"
					overlayClassName="profile-popover"
					open={isPopoverOpen}
					onOpenChange={(e) => setIsPopoverOpen(e)}
				>
					<Button type="text" className="text-white menu-btn">
						<Space>
							{showProfile()}
							<span className="text-white">{username}</span>
						</Space>
					</Button>
				</Popover>
			</Space>
		</Header>
	);
};

export default Headers;
